"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TooltipTextRequestModel = /** @class */ (function () {
    function TooltipTextRequestModel(visualIdPresModel, tupleId) {
        this.visualIdPresModel = visualIdPresModel;
        this.tupleId = tupleId;
    }
    return TooltipTextRequestModel;
}());
exports.TooltipTextRequestModel = TooltipTextRequestModel;
//# sourceMappingURL=AccessibilityModels.js.map